// extracted by mini-css-extract-plugin
export default {"footer":"match_card_footer-module___footer___de33b340"};